var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},_vm._l((_vm.related),function(to,i){return _c('v-col',{key:i,attrs:{"cols":"12","sm":"6","lg":"4"}},[_c('related-page',{attrs:{"to":to}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }